import * as React from 'react';
import { CustomButton, ButtonType } from "soprasteria-ui-library";
import { useHistory } from 'react-router';

interface IInvoiceAdministrationButtons {
    canApproveInvoice?: boolean;
    canAttestInvoice?: boolean;
}

export const InvoiceAdministrationButtons: React.FunctionComponent<IInvoiceAdministrationButtons> = ({ canApproveInvoice, canAttestInvoice }) => {

    const history = useHistory();

    return (
        <>
            <div className="row">
                <div className="col-6 text-left">
                    <CustomButton buttonType={ButtonType.general} onClick={() => history.goBack()} buttonText="Gå tillbaka" />
                </div>
                <div className="col-6 text-right">
                    {
                        canApproveInvoice ?
                            <CustomButton buttonType={ButtonType.success} buttonText="Godkänn faktura" data-target="#approve-invoice-modal" data-toggle="modal" />
                            : null
                    }
                    {
                        canAttestInvoice ?
                            <CustomButton buttonType={ButtonType.warning} buttonText="Attestera faktura" data-target="#attest-invoice-modal" data-toggle="modal" />
                            : null
                    }
                </div>
            </div>
        </>
    )
}

